export const login = {
  loginResponse: 'loginResponse',
}

export const navigation = {
  error: "/",
  landing: '/logout',
  login: '/login',
  dashboard: '/',
  componentNavigation: {
    "1001": '/',
    "1002": '/final-recommendation',
    "1003": '/price-performance',
    "1004": '/price-recommendation',
    "1006": '/scenario',
    "1007" : '/competitor',
    "2003": '/scenario/scenario-planner',
    "2004": '/scenario/scenario-comparision',
    "2005": '/price-recommendation/recommendation-list',
    "2006": '/price-recommendation/priceband-configuration'
  },
  dashboardNavigation: {
    "1001": '/',
    "1002": '/final-recommendation',
    "1003": '/price-performance',
    "1004": '/price-recommendation/recommendation-list',
    "1006": '/scenario/scenario-planner',
    "1007" : '/competitor'
  },
  scenarioLanding: '/scenario/scenario-planner',
  approvedScenariosLanding: '/scenario/approved-scenario',
  approvedScenariosPriceBand: '/scenario/approved-scenario/approver-price-band',
  approvedScenariosSKU: '/scenario/approved-scenario/approver-sku',
  scenarioSKUPriceTier: '/scenario/scenario-planner/scenario-sku',
  scenarioPriceTier: '/scenario/scenario-planner/scenario-price-tier',
  createSceanrio: '/scenario/scenario-planner/create-scenario',
  recommendationLanding: '/final-recommendation',
  recommendationLandingInReview: '/final-recommendation/in-review',
  recommenationPriceTier: '/final-recommendation/recommendation-price-tier',
  recommenationComparison: '/final-recommendation/recommendation-comparison',
  recommendationSKU: '/final-recommendation/recommendation-sku',
  recommendationComparisonSku: '/final-recommendation/recommendation-comparison-sku',
  priceRecommendationLanding: '/price-recommendation/recommendation-list',
  priceRecommenationPriceTier: '/price-recommendation/recommendation-list/recommendation-price-tier',
  priceRecommendationSKU: '/price-recommendation/recommendation-list/recommendation-sku',
  scenarioComparisonResult: '/scenario/scenario-comparision/result',
  newpricerecommender: '/price-recommendation/recommendation-list/new-price-recommender',
  priceRangingSummary: '/final-recommendation/price-range-summary',
  competitorLanding: '/competitor',
}

export const currencyFormat = {
  digitFormat: 0.00,
}

export const common = {
  skip_market : 'Skip-Market',
  gmap_url :'https://maps.googleapis.com/maps/api/js?key=',
  sucess_response: 200,
  failure_response: 500,
  move_to_in_market_failure: 405,
  msalTokenKeys: 'msal.token.keys',
  authorization: 'Authorization',
  bearer: 'Bearer ',
  unauthorizeStatusCode: 401,
  zero: 0,
  itemSize: 40,
  priceTierItemSize: 20,
  headerHeight: 50,
  totalViewPortRange: 460,
  bufferRange: 80,
  closeExpansionPanel: -1,
  defaultViewPort: 100,
  defaultRegion: '',
  defaultRegionCode: 99,
  defaultRegionId: '',
  defaultTableHeight: 200,
  defaultTableHeightForOptimizer: 250,
  none: 'none',
  block: "block",
  locale: 'en-US',
  lang_symbol: 'lang_symbol',
  display_none: 'none',
  display_block: 'block',
  session_storage: 'session_storage',
  local_storage: 'local_storage',
  indexed_db: 'indexed_db',
  indexed_db_name: 'costa_db',
  indexed_db_store: 'costa_store',
  withoutTimezoneConversion: 'YYYY-MM-DD 00:00:00',
  withoutTimezoneConversionJustDate: 'YYYY-MM-DD',
  withoutTimezoneConversionwithoutDate: 'YYYY-MM',
  withoutTimezoneConversionJustDate2: 'yyyy-MM-dd',
  home_code: '1001',
  default_page_size: 50,
  one: 1,
  download_success: "lang.common.download_success",
  max_scenarios_for_inmarket: "lang.recommendation.max_scenarios_for_inmarket",
  absolute: "absolute",
  percentage: "percentage",
  notification_time : 5* 60 * 1000,
  no_data_found: "lang.common.no_data_found",
  date_error: "lang.common.date_error",
}

export const dashboard = {
  dashboard_data: []
}

export const encryptKey = {
  characters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
}

export const scenario = {
  delete_message: "lang.scenerio.delete_message",
  default_sorting_column: 'price_tier_id',
  default_sorting_direction: 'asc',
  file_name: "lang.scenerio.file_name",
  violation_file_name: "lang.scenerio.vioaltion_file_name",
  recalculated_rows: "lang.scenerio.recalculated_rows",
  upload_recalculate_success: "lang.scenerio.upload_success",
  delete_success: 'lang.scenerio.delete_success',
  approve_failure: 'lang.scenerio.approve_failure',
  reject_failure: 'lang.scenerio.reject_failure',
  approve_success: 'lang.scenerio.approve_success',
  approval_success: 'lang.scenerio.approval_success',
  reject_success: 'lang.scenerio.reject_success',
  override_successful: 'lang.scenerio.override_successful',
  scenario_recommender:'lang.scenerio.scenario_recommender',
  price_hierarchy_columns :['priceBand','food', 'beverages'],

  scenario_type: {
    'scenerio_planner': 'sp',
    'optimiser': 'opt',
  },

  scenerio_table_columns: ['select', 'scenario_id', 'name', 'objective', 'market', 'description', 'created_by', 'created_at', 'status_name', 'parent_optimizer_id', 'pricing_cycle_date', 'constraints_rules', 'action'],
  common_columns: ['price_tier','category_l1', 'category_l2','sub_category', 'sku_id', 'sku_name'],
  column_selection: [
    { column_id: 'current_price', column_name: 'lang.scenerio.price_tier_table.current_price' },
    { column_id: 'recommended_price', column_name: 'lang.scenerio.price_tier_table.recommended_price' },
    { column_id: 'scenario_price', column_name: 'lang.scenerio.price_tier_table.final_instore_price' },
    { column_id: 'price_change', column_name: 'lang.scenerio.price_tier_table.price_change' },
    { column_id: 'base_units', column_name: 'lang.scenerio.price_tier_table.base_units' },
    { column_id: 'estimated_units_lb', column_name: 'lang.scenerio.price_tier_table.estimated_units' },
    { column_id: 'gross_margin_lb', column_name: 'lang.scenerio.price_tier_table.weekly_margin' },
    { column_id: 'price_sensitivity', column_name: 'lang.scenerio.price_tier_table.price_sensitivity' },
    { column_id: 'avg_comp_price', column_name: 'lang.scenerio.price_tier_table.avg_competitor_price' }
  ],
  approved_scenerio_table_columns: ['scenario_id', 'name', 'market', 'description', 'created_by', 'created_at', 'status_code', 'price_rec_id', 'pricing_cycle_date'],  //'select',
  table_columns_with_price_tier: ['price_tier', 'category_l1', 'category_l2', 'sub_category', 'sku_id', 'sku_name',  'price_sensitivity', 'current_price', 'recommended_price', 'scenario_price', 'price_change', 'base_units', 'estimated_units_lb', 'gross_margin_lb', 'avg_comp_price'],
  table_columns_without_price_tier: ['category_l1', 'category_l2', 'sub_category', 'sku_id', 'sku_name',  'price_sensitivity', 'current_price', 'recommended_price', 'scenario_price', 'price_change', 'base_units', 'estimated_units_lb', 'gross_margin_lb', 'avg_comp_price'],
  export_scenario:"lang.scenerio.export_scenario",
  export_scenario_pb:"lang.scenerio.export_scenario_pb",
  price_hierarchy_error:{
    category_error:"lang.scenerio.price_hierarchy_error.category_error",
    general_error:"lang.scenerio.price_hierarchy_error.general_error",
  }

}

export const recommendation = {
  recommendation_table_approved_columns: ['scenario_id', 'name', 'market', 'approved_at', 'approved_by', 'pricing_cycle_date', 'stores_impacted', 'status_name'], //, 'includes_franchise'
  recommendation_table_in_review_columns: ['select', 'scenario_id', 'name', 'market', 'modified_at', 'modified_by', 'pricing_cycle_date', 'stores_impacted', 'status_name'], //, 'includes_franchise'
}

export const storage_keys = {
  configuration: 'configuration',
  user_name: 'user_name',
  role_id: 'role_id',
  api_keys: 'api_keys'
}

export const impact_screen = {
  percentage_decimal: 2,
  absolute_decimal: 2,
  default_estimated_week_id: 'weekly',
  default_estimated_category_id: null
}

export const configuration_keys = {
  date_range_value: 'scenario_summary_date_range',
  default_date_range_value: 'scenario_summary_date_range_default',
  date_format: 'date_format',
  language_code: 'language_code',
  currency_symbol: 'currency_symbol',
  currency_name: 'currency_name',
  price_hierarchy_range_max: 'price_hierarchy_range_max',
  price_hierarchy_range_min: 'price_hierarchy_range_min',
  time_restriction_for_recommendation_creation:'time_restriction_for_recommendation_creation',
  planning_cycle_date_min: 'planning_cycle_date_min',
  planning_cycle_date_max: 'planning_cycle_date_max',
  price_range_1: 'price_range_1',
  price_range_2: 'price_range_2',
  price_range_3: 'price_range_3',
  percentage_decimal: 'percentage_decimal'
}

export const scenario_price_tier = {
  price_tier_table_columns: ['price_tier', 'stores', 'sku_affected', 'price_change', 'atv', 'sales', 'transaction', 'margin', 'estimated_units_lb'] //, 'last_saved_by', 'last_saved_on', 'weekly_gm'
}

export const translate_text = {
  mandatory_validation: 'lang.validation_messages.mandatory_validation',
  scenario_created_message :'lang.validation_messages.scenario_careted_message',
  scenario_created_message_beginning :'lang.validation_messages.scenario_careted_message_beginning',
  scenario_created_message_ending :'lang.validation_messages.scenario_careted_message_ending',
  valid_price_error :"lang.validation_messages.valid_price_error",
  valid_percentage_error : "lang.validation_messages.valid_percentage_error"
}

export const recommended_price_tier = {
  price_tier_table_columns: ['price_tier', 'stores', 'sku_affected', 'price_change', 'atv', 'sales', 'transaction', 'margin', 'estimated_units_lb'] //, 'last_saved_by', 'last_saved_on', 'weekly_gm'
}

export const price_recommender_price_tier_table = {
  price_tier_table_columns: ['price_tier','stores', 'sku_affected', 'price_change', 'atv', 'sales', 'transaction', 'margin', 'estimated_units_lb']   //, 'weekly_gm'
}

export let sortHeaders_price_tier_table :any = {
    'price_tier': "price_tier",
    'stores': 'stores',
    'sku_affected': 'products_affected',
    'price_change': 'percentage_price_change',
    'sales' : 'perc_sales',
    'transaction' : 'perc_transactions',
    'weekly_gm': 'weekly_gross_margin',
    'margin': 'perc_gross_margin',
    'estimated_units_lb': 'estimated_units',
    'atv': 'atv'
}

export let sortHeaders_sku_table :any = {
    'price_tier': 'price_tier',
    'objective': 'objective',
    'category_name': 'category_name',
    'sku_id': 'sku_id',
    'sku_name': 'sku_name',
    'current_price' : 'current_price',
    'recommended_price' : 'recommended_price',
    'scenario_price': 'scenario_price',
    'price_change': 'price_change',
    'base_units': 'base_units',
    'estimated_units_lb': 'estimated_units',
    'gross_margin_lb': 'gross_margin',
    'price_sensitivity': 'price_sensitivity',
    'avg_comp_price': 'avg_comp_price',
    'category_l1': 'category_lvl1_name',
    'category_l2': 'category_lvl2_name',
    'sub_category': 'sub_category_name'
}

export const impact_arrow_indicators = {
  arrow_up: 1,
  arrow: 0,
  arrow_down: -1,
}

export const price_recommender = {
  landing_table_columns: ["scenario_id", "name", "objective", "market", "description", "created_by", "created_at", "pricing_cycle_date", "status_name", "constraints_rules"],  //, "error_logs"
  constraint_pop_up_table_columns: ['constraint_type', 'constraint_drill', 'minimum_value', 'maximum_value'],
  item_details_pop_up_table_columns: ['product_category', 'items']
}
export const scenario_comparison = {
  page_size: 5,
  scenerio_table_columns: ['select', 'scenario_id', 'name', 'description', 'created_by', 'created_at', 'status_code'],
  stores: 'stores'
}

export const unitsByKb = {
  kb: 1,
  mb: 1024,
  fileSize: 200
}

export const donwloadFormates: any = {
  excel: {
    type: 'application/vnd.ms-excel',
    extensions: '.xlsx',
    value: 'excel'
  },
  pdf: {
    type: 'application/pdf',
    extensions: '.pdf',
    value: 'pdf'
  },
  zip: {
    type: 'application/zip',
    extensions: '.zip',
    value: 'zip'
  },
}

export const newPriceRecommender: any = {
  toastMessageCls: "toast-message-cls",
  categoryTable: "category-table",
  constraintsTable: "constraints-table",
  uploadDialogHeight: "488px",
  uploadDialogPanelClass: "custom-dialog-container",
  generateDialogHeight: "175px",
  generateDialogWidth: "454px",
  generateDialogPanelClass: "generate-dialog-container",
  createNewRecommenderDialogHeight: "460px",
  createNewRecommenderDialogWidth: "460px",
  createNewRecommenderDialogPanelClass: "createNewRec-dialog-container",
  minValue: 'min',
  maxValue: 'max',
  all:"All",
  categoryTableColumns: ['Category', 'Products', 'action'],
  constraintTableColumns: ['constraint_type', 'constraint_description', 'minimum_value', 'maximum_value', 'action'],
  maximizeRevenue: "maximize_revenue",
  maximizeGrossMargin: "maximize_gross_margin",
  maximizePercGrossMargin: "maximize_perc_gross_margin",
  newMaxValue: "new_max_value",
  newMinValue: "new_min_value",
  all_items_value: 1,
  few_items_value: 0,
  download_error_message:"lang.new_price_recommender.download_error_message",
  duplicate_products_exists:"lang.new_price_recommender.error_messages.duplicateItemsCannotBeAdded",
  duplicate_constraints_exists:"lang.new_price_recommender.error_messages.duplicateConstraintsCannotBeAdded",
  constraints_is_mandatory:"lang.new_price_recommender.error_messages.constraintsIsMandatory",
  Please_Fill_Required_Fields:"lang.new_price_recommender.error_messages.PleaseFillRequiredFields",
  Pleas_Select_Distinct_All_Products:"lang.new_price_recommender.error_messages.PleasSelectDistinctAllProducts"

}

export const chart_constants: any = {
  chart_colors : {
    pink: "#CFA8CA",
    green: "#3cb44b",
    light_blue: "#B0DDF5",
    orange: "#F58E90",
    yellow: "#FDCB4E",
    brown: "#9A6324",
    red: '#E52F25',
    purple: "#CF9FFF",
    teal: "#469990",
    lime: "#bfef45",
    costa: "#6B1831",
    light_blue_transparent: "#B0DDF510",
  },
  chart_inc_dec : {
    increase: 'Increase',
    decrease: 'Decrease',
    total: 'Total',
  },
  chart_axis_ids: {
    bar_axis: 'bar_axis',
    line_axis: 'line_axis'
  }
}

export const price_ranging_summary: any = {
  ranging_summary_table1_columns: ['products', 'price_range_1', 'price_range_2', 'price_range_3', 'price_range_4'],
  ranging_summary_table2_columns: ['products', 'price_barrier_1', 'price_barrier_2', 'price_barrier_3'],  
}

export const competitor : any ={
  data_column :["category","sku_name","current_price"],
  restaurantColumn: ['header-row-first-group',"costa"],
}


export const price_performance: any = {
  est_v_act_table_cols: ['price_band', 'est_sales_impact', 'actual_sales_impact','est_units_impactt', 'actual_units_impactt', 'est_transaction_impact', 'actual_transaction_impact'],
  price_band_analysis_hierarchy_cols: ["price_index", "price_band_1", "price_band_2", "price_band_3", "price_band_4", "price_band_5", "price_band_6", "scotland"],
  price_band_analysis_segmentation_cols: ["row", "price_band_1", "price_band_2", "price_band_3", "price_band_4", "price_band_5", "price_band_6", "scotland", "grand_total"],
  periodConfig: {
      week: { rotate: 90, x_axis_name_gap: 75, grid: { bottom: '16%' } },
      month: { rotate: 45, x_axis_name_gap: 50, grid: { bottom: '15%' } },
      default: { rotate: 0, x_axis_name_gap: 30, grid: { bottom: '15%' } }
    },
}

export const notification : any = {
  notification_desc : "lang.notification.notification_desc",
  generated_success : "lang.notification.generated_success",
  yesterday:"YESTERDAY",
  today:"TODAY",
  min_ago:"min ago",
  hr_ago:"hr ago",
  two_digits:"2-digit",
  failed:"lang.notification.failed",
  submitted_scenario:"lang.notification.submitted_scenario",
  submit_for_approval: "lang.notification.submit_for_approval",
  rejected_message : "lang.notification.rejected_message",
  approval:"lang.notification.approval",
  approved:"lang.notification.approved",
  rejected:"lang.notification.rejected",
  image_url : "./../../../assets/images/navBarIcons/circle-user-regular.svg"

}

export const price_band_graphs: any = {
  disable_absolute_toggle_metric: 'WAP_Change',
}

export const scroll: any ={
  classes: {
    scenario_planner : '.scenario_planner',
    price_recommender: '.price_recommender',
    recommendation_landing: '.recommendation_landing',
    price_band_analysis: '.pb_segmentation'
  },
  default_mouse_speed : 0.99
}

export const settings : any ={
  columnData : ['column1', 'column2'],
  price_mapping_message: 'lang.pricebandConfiguration.price_band_mapping_not_available'
}